module.exports = [
  {
    key: 'SHERYL',
    avatarOptions: {
      upperUnderwear: true,
      bodyType: 'ADULT',
      genderType: 'FEMALE',
      defaultOutfit: 'OUTFIT_2',
      defaultIslamicOutfit: 'OUTFIT_2_x_ISLAMIC'
    },
    name: {
      en: 'Sheryl',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/VRP_Avatars__0000_Sheryl.png',
    },
    pollyEngine: {
      en: 'neural',
      es: null,
    },
    pollyVoiceId: {
      en: 'Kimberly',
      es: 'Penelope',
    },
  },
  {
    key: 'AMY',
    avatarOptions: {
      upperUnderwear: true,
      bodyType: 'ADULT',
      genderType: 'FEMALE',
      defaultOutfit: 'OUTFIT_4',
      defaultIslamicOutfit: 'OUTFIT_4_x_ISLAMIC'
    },
    name: {
      en: 'Amy',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/VRP_Avatars__0003_Amy.png',
    },
    pollyEngine: {
      en: 'neural',
      es: null,
    },
    pollyVoiceId: {
      en: 'Salli',
      es: 'Conchita',
    },
  },
  {
    key: 'BEN',
    avatarOptions: {
      bodyType: 'ADULT',
      genderType: 'MALE',
      defaultOutfit: 'OUTFIT_3'
    },
    name: {
      en: 'Ben',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/VRP_Avatars__0004_Ben.png',
    },
    pollyEngine: {
      en: 'neural',
      es: null,
    },
    pollyVoiceId: {
      en: 'Matthew',
      es: 'Enrique',
    },
  },
  {
    key: 'HAWTHORN',
    avatarOptions: {
      bodyType: 'ADULT',
      genderType: 'MALE',
      defaultOutfit: 'OUTFIT_2'
    },
    name: {
      en: 'Hawthorn',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/VRP_Avatars__0002_Hawthorn.png',
    },
    pollyEngine: {
      en: 'neural',
      es: null,
    },
    pollyVoiceId: {
      en: 'Brian',
      es: 'Miguel',
    },
  },
  {
    key: 'PATRICIA',
    avatarOptions: {
      upperUnderwear: true,
      bodyType: 'ADULT',
      genderType: 'FEMALE',
      defaultOutfit: 'OUTFIT_3',
      defaultIslamicOutfit: 'OUTFIT_3_x_ISLAMIC',
    },
    name: {
      en: 'Patricia',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/VRP_Avatars__0005_Patricia.png',
    },
    pollyEngine: {
      en: 'neural',
      es: null,
    },
    pollyVoiceId: {
      en: 'Joanna',
      es: 'Conchita',
    },
  },
  {
    key: 'JOSHUA',
    avatarOptions: {
      bodyType: 'ADULT',
      genderType: 'MALE',
      defaultOutfit: 'OUTFIT_4',
    },
    name: {
      en: 'Joshua',
      es: null,
    },
    picture: {
      url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/avatars/VRP_Avatars__0001_Joshua.png',
    },
    pollyEngine: {
      en: 'standard',
      es: null,
    },
    pollyVoiceId: {
      en: 'Geraint',
      es: 'Enrique',
    },
  },
  {
    key: 'LIAM',
    avatarOptions: {
      bodyType: 'OBESE',
      genderType: 'MALE',
      defaultOutfit: 'OUTFIT_1'
    },
    name: {
      en: 'Liam',
      es: null
    },
    picture: {
      url: 'https://s3.us-west-2.amazonaws.com/assets.vrpatients.net/avatars/VRP_Avatars__0006_Liam.png'
    },
    pollyEngine: {
      en: 'neural',
      es: null
    },
    pollyVoiceId: {
      en: 'Joey',
      es: 'Miguel'
    }
  },
  {
    key: 'KIM',
    avatarOptions: {
      upperUnderwear: true,
      bodyType: 'OBESE',
      genderType: 'FEMALE',
      defaultOutfit: 'OUTFIT_1',
      defaultIslamicOutfit: 'OUTFIT_1_x_ISLAMIC'
    },
    name: {
      en: 'Kim',
      es: null
    },
    picture: {
      url: 'https://s3.us-west-2.amazonaws.com/assets.vrpatients.net/avatars/VRP_Avatars__0006_Kim.png'
    },
    pollyEngine: {
      en: 'neural',
      es: 'neural'
    },
    pollyVoiceId: {
      en: 'Kendra',
      es: 'Mia'
    }
  },
];
